import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppRoutes from './routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from 'react-modal';
import { Provider } from 'react-redux';

Modal.setAppElement('#root');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <AppRoutes />
);

reportWebVitals();
